export default __webpack_public_path__ + "static/media/not_registered.be2983cb.svg";